import $ from 'jquery';
import { KEYS, IDS, ENDPOINTS } from '../constants';
import { getItem, setItem } from '../helpers/storage';

const AIRPORTS_APP = {
  app_id: IDS.AIRPORT_APP_ID,
  app_key: KEYS.AIRPORT_APP_KEY
};

const LOUNGES_APP = {
  app_id: IDS.LOUNGES_APP_ID,
  app_key: KEYS.LOUNGES_APP_KEY
};

export const AIRPORTS_CACHE_KEY = 'OW_AIRPORTS';
const AIRLINES_CACHE_KEY = 'OW_AIRLINES';

export async function getAirports(options = {}) {
  let airports = getItem(AIRPORTS_CACHE_KEY),
    url = ENDPOINTS.getAirports;

  if (!airports) {
    let data = { ...AIRPORTS_APP };

    if (options.data) {
      data = { ...options.data, ...AIRPORTS_APP };
    }
    if (options.url) {
      url = options.url;
    }

    const config = {
      type: 'GET',
      dataType: 'JSON',
      ...options,
      url,
      data
    };

    airports = await $.ajax(config);
    setItem(AIRPORTS_CACHE_KEY, airports);
  }

  return airports;
}

export function findLounges({ airport, url, ...options } = {}) {
  let data = { ...LOUNGES_APP },
    baseUrl = ENDPOINTS.findLounges;

  if (url) {
    baseUrl = url;
  }

  if (options.data) {
    data = { ...options.data, ...AIRPORTS_APP };
  }

  baseUrl = `${baseUrl}/${airport}`;

  return $.ajax({
    url: baseUrl,
    type: 'GET',
    dataType: 'JSON',
    ...options,
    data
  });
}

export async function searchAirportFastTrack(airportCode) {
  return $.ajax({
    url: `/api/airport?airportCode=${airportCode}`,
    type: 'GET',
    dataType: 'JSON'
  })
}

export async function searchFlights(
  url,
  { from, to, departureDate, returnDate } = {}
) {
  let baseUrl = ENDPOINTS.searchFlights;

  if (url) {
    baseUrl = url;
  }

  return $.getJSON(`${baseUrl}/${from}/${to}`, {
    appKey: KEYS.ONEWORLD_APP_KEY,
    appId: IDS.ONEWORLD_APP_ID,
    departureDate,
    returnDate
  });
}

export async function getAirlines() {
  let airlinesObj = getItem(AIRLINES_CACHE_KEY);

  if (!airlinesObj) {
    const url = ENDPOINTS.getAirlines;
    const airlines = await $.getJSON(`${url}`, {
      appKey: KEYS.ONEWORLD_APP_KEY,
      appId: IDS.ONEWORLD_APP_ID
    });
    airlinesObj = airlines.reduce((acc, airline) => {
      acc[airline.code] = airline;
      return acc;
    }, {});

    setItem(AIRLINES_CACHE_KEY, airlinesObj);
  }

  return airlinesObj;
}

export function getDeepLinkUrl(route, params) {
  const { from, to, departureDate, returnDate } = params;
  const { routeOperatingCarrierCode, legs, routeDepartureDateCode } = route;

  let cityFrom = 'XXX',
    cityTo = 'XXX',
    countryFrom = 'XX',
    countryTo = 'XX';

  if (legs && legs.length) {
    const firstLeg = legs[0];
    const lastLeg = legs[legs.length - 1];

    cityFrom = firstLeg.departureCityCode || 'XXX';
    cityTo = lastLeg.arrivalCityCode || 'XXX';
    countryFrom = firstLeg.departureCountryCode || 'XX';
    countryTo = lastLeg.arrivalCountryCode || 'XX';
  }

  const qs = [
    `appKey=${KEYS.ONEWORLD_APP_KEY}`,
    `appId=${IDS.ONEWORLD_APP_ID}`,
    `from=${from}`,
    `to=${to}`,
    `cityFrom=${cityFrom}`,
    `cityTo=${cityTo}`,
    `countryFrom=${countryFrom}`,
    `countryTo=${countryTo}`,
    `departureDate=${departureDate}`,
    `routeDepartureDateCode=${routeDepartureDateCode}`
  ];
  if (returnDate) {
    qs.push(`returnDate=${returnDate}`);
  }
  return `${ENDPOINTS.deepLink}/${routeOperatingCarrierCode}?${qs.join('&')}`;
}

export function getFlightBookForm(url) {
  return $.ajax({
    url,
    type: 'GET',
    dataType: 'html'
  });
}

export function getFlightBookUrl({ url, type, data }) {
  return $.ajax({
    url,
    type,
    dataType: 'JSON',
    data
  });
}
